import React from 'react'

import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import SearchField from '../logs/logSearchField'

interface ListHeaderProps {
  headerText: string
  searchPlaceholder: string
  typeString: string
  totalResults: number | string
  isSearchFieldHidden?: boolean
  children?: React.ReactNode
  onSearch: (searchString: string) => void
}

const ListHeader = (props: ListHeaderProps) => {
  return (
    <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
      <Stack>
        <Typography component="h1" variant="h4">
          {props.headerText}
        </Typography>
        <Typography variant="caption">{`${props.totalResults} ${props.typeString}`}</Typography>
      </Stack>
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems="center" spacing={1}>
        <Stack sx={{ display: props.isSearchFieldHidden ? 'none' : 'flex' }}>
          <SearchField placeholder={props.searchPlaceholder} onSearch={props.onSearch} />
        </Stack>
        {props.children}
      </Stack>
    </Stack>
  )
}

export default ListHeader
